import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { setupStore } from './store/store';
import { BrowserRouter, HashRouter, RouterProvider, createBrowserRouter } from "react-router-dom";

import sanitizedConfig from './Config';

Sentry.init({
  dsn: sanitizedConfig.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  ignoreTransactions: ["/"],

  tracesSampleRate: Number(window._env_.SENTRY_TRACES_RATE ?? 0.01),

  tracesSampler: (samplingContext) => {
    if (samplingContext.name === "signing EDS") {
      return Number(window._env_.SENTRY_TRACES_RATE_SIGN ?? 1.0)
    }

    return Number(window._env_.SENTRY_TRACES_RATE ?? 0.01)
  },

  tracePropagationTargets: [
    "localhost",
    ...(
      sanitizedConfig?.REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS?.split(',')?.map(str => str.trim()) ?? []
    )
  ],
})

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const store = setupStore();

// const router = createBrowserRouter([
//     {
//         path: "/",
//         element: <Provider store={store}>
//             <App />
//         </Provider>,
//     },
// ]);

root.render(
    <HashRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
